import React from 'react'

import TransportCards from '../../../react4xp/components/TransportCards'

function TransportCardsPart({ content }) {
    return (
		<TransportCards 
            section={{ bgColor: 'red'}}
            content={content}
        />
    )
}

export default (props) => <TransportCardsPart {...props} />
